module.exports = __webpack_public_path__ + "img/HA2513-188.fec86bc0.jpg";